import Link from "ds/components/Link";
import { RunPriorityPreset } from "types/generated";
import { getDocsUrl } from "utils/getDocsUrl";

type ReadMoreProps = {
  path: string;
};

const ReadMore = ({ path }: ReadMoreProps) => (
  <Link href={path} rel="noopener noreferrer" target="_blank" size="small" variant="inversed">
    Read more.
  </Link>
);

export const projectRootTooltipContent = (
  <>
    Project root is the optional directory relative to the workspace root containing the entrypoint
    to the Stack. <ReadMore path={getDocsUrl("/concepts/stack/stack-settings#project-root")} />
  </>
);

export const runProjectRootTooltipContent = (
  <>
    Project root is the directory relative to the workspace root used for this run. It may differ
    from the stack's configured project root if overridden via runtime configuration.
  </>
);

export const runModuleProjectRootTooltipContent = (
  <>
    Project root is the directory relative to the repository root used for this run. It may differ
    from the module's configured project root if overridden via runtime configuration.
  </>
);

export const RunProposedTooltip = (
  <>
    Proposed runs are previews of changes that would be applied to your infrastructure if the new
    code was to somehow become canonical, for example by pushing it to the tracked branch.{" "}
    <ReadMore path={getDocsUrl("/concepts/run/proposed")} />
  </>
);

export const RunTrackedTooltip = (
  <>
    Tracked runs represent the actual changes to your infrastructure caused by changes to your
    infrastructure definitions and/or configuration.{" "}
    <ReadMore path={getDocsUrl("/concepts/run/tracked")} />
  </>
);

const RUN_PRIORITY_ORDERING_COPY: Record<RunPriorityPreset, string> = {
  [RunPriorityPreset.High]: "High priority runs are processed before runs from other stacks.",
  [RunPriorityPreset.Normal]: "Runs are processed in the order they were queued.",
  [RunPriorityPreset.Low]: "Low priority runs are processed after runs from other stacks.",
};

export const getRunPriorityTooltip = (preset: RunPriorityPreset) => (
  <>
    {RUN_PRIORITY_ORDERING_COPY[preset]} However, a stack's standard order of run types (tasks,
    tracked, and proposed runs) execution will still be respected.{" "}
    <ReadMore path={getDocsUrl("/concepts/run/#run-prioritization")} />
  </>
);
